import { configureStore } from "@reduxjs/toolkit";
import propertyReducer from "./propertySlice";
import authReducer from "./authSlice";
import employeeReducer from "./employeeSlice";
import clientReducer from "./clientSlice";
import repairsReducer from "./repairSlice";
import toastReducer from "./toastSlice";
import unitsReducer from "./unitSlice";
import unitCustomFieldsReducer from "./unitCustomFieldSlice";
import contractHistoryReducer from "./contractHistorySlice";
import contractsReducer from "./contractSlice";
import customersReducer from "./customerSlice";
// 旧 slice (PrivateAreaDetail / RentRoll 等の既存 UI 維持用)。新規動線は unit* slice を使う。
import propertySectionsReducer from "./propertySectionSlice";
import equipmentReducer from "./equipmentSlice";
import documentManagementReducer from "./documentManagementSlice";
import categoryManagementReducer from "./categoryManagementSlice";
import chatReducer from "./chatSlice";
import sidebarReducer from "./sidebarSlice";
import paymentReducer from "./paymentSlice";
import paymentOptionManagementReducer from "./paymentOptionManagementSlice";
import groupOptionManagementReducer from "./groupOptionManagementSlice";
import relatedLawManagementReducer from "./relatedLawManagementSlice";
import budgetReducer from "./budgetSlice";
import budgetAnalysisReducer from "./budgetAnalysisSlice";
import expenseReducer from "./expenseSlice";
import recurringExpenseReducer from "./recurringExpenseSlice";
import inspectionReducer from "./inspectionSlice";
import managementTaskReducer from "./managementTaskSlice";
import managementTaskResultReducer from "./managementTaskResultSlice";
import managementTaskCustomFieldReducer from "./managementTaskCustomFieldSlice";
import expenseCustomFieldReducer from "./expenseCustomFieldSlice";

export const store = configureStore({
  reducer: {
    property: propertyReducer,
    auth: authReducer,
    employees: employeeReducer,
    clients: clientReducer,
    repairs: repairsReducer,
    toast: toastReducer,
    units: unitsReducer,
    unitCustomFields: unitCustomFieldsReducer,
    contractHistory: contractHistoryReducer,
    contracts: contractsReducer,
    customers: customersReducer,
    propertySections: propertySectionsReducer,
    equipmentMgmt: equipmentReducer,
    documentManagement: documentManagementReducer,
    categoryManagement: categoryManagementReducer,
    chat: chatReducer,
    sidebar: sidebarReducer,
    payments: paymentReducer,
    paymentOptionManagement: paymentOptionManagementReducer,
    groupOptionManagement: groupOptionManagementReducer,
    relatedLawManagement: relatedLawManagementReducer,
    budgets: budgetReducer,
    budgetAnalysis: budgetAnalysisReducer,
    expenseMgmt: expenseReducer,
    recurringExpenses: recurringExpenseReducer,
    inspections: inspectionReducer,
    managementTasks: managementTaskReducer,
    managementTaskResults: managementTaskResultReducer,
    managementTaskCustomFields: managementTaskCustomFieldReducer,
    expenseCustomFields: expenseCustomFieldReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
